export default __webpack_public_path__ + "static/media/openai.b29c99dc.svg";